import useTranslation from 'next-translate/useTranslation'

import Button from '@/atoms/Button/Button'
import { showModal } from '@/store/slices/modal'

function LastSection() {
  const { t } = useTranslation('forCreators')

  const openAuthModal = () => showModal('auth', 'providers')

  return (
    <div className="py-16 text-center border-2 border-l-0 border-r-0 md:p-16 border-gray-5">
      <div className="flex flex-col items-center justify-center space-y-8">
        <h2 className="text-2xl font-medium sm:text-3xl lg:text-6xl">
          {t('is_it_sound_interesting')}
        </h2>
        <p className="sm:text-xl lg:text-2xl">
          {t('is_it_sound_interesting_desc')}
        </p>
        <Button
          text={t('signup')}
          variant="flat-full"
          className="p-2 text-sm px-11 lg:py-4 md:px-20 md:text-base"
          onClick={openAuthModal}
        />
      </div>
    </div>
  )
}

export default LastSection
